import React from 'react';
import { Link } from 'react-router-dom';
import ShelterCareConnectLogo from '../ui/logo';

const MarketingLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white">
      {/* Marketing Navigation */}
      <nav className="bg-blue-600 text-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-4">
              <Link to="/" className="flex items-center">
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-white rounded-lg p-1 shadow-lg flex items-center justify-center">
                    <img 
                      src="/shelter-logo.jpg" 
                      alt="Shelter Care Connect Logo" 
                      className="w-full h-full object-contain rounded"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextElementSibling.style.display = 'block';
                      }}
                    />
                    <span className="text-blue-600 font-bold text-xs hidden">LOGO</span>
                  </div>
                  <span className="text-white text-2xl font-bold">Shelter Care Connect</span>
                </div>
              </Link>
            </div>
            
            <div className="hidden md:flex space-x-6">
              <Link to="/" className="hover:text-blue-200">Home</Link>
              <Link to="/features" className="hover:text-blue-200">Features</Link>
              <Link to="/preview" className="hover:text-blue-200">Preview</Link>
              <Link to="/demo" className="hover:text-blue-200">Live Demo</Link>
              <Link to="/beta" className="hover:text-blue-200">Beta Testing</Link>
            </div>

            <div className="flex space-x-4">
              <Link
                to="/demo"
                className="bg-white/10 hover:bg-white/20 border border-white/40 px-4 py-2 rounded font-semibold"
                data-testid="marketing-try-demo"
              >
                Try the Demo
              </Link>
              <Link
                to="/signup"
                className="bg-green-500 hover:bg-green-600 px-4 py-2 rounded font-semibold"
                data-testid="marketing-get-started"
              >
                Get Started Free
              </Link>
              <Link 
                to="/login" 
                className="bg-blue-500 hover:bg-blue-400 px-4 py-2 rounded font-semibold"
              >
                Login to App
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Page Content */}
      <main>
        {children}
      </main>

      {/* Simple Footer */}
      <footer className="bg-gray-800 text-white py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-xl font-bold mb-2">Shelter Care Connect</p>
          <p className="text-gray-300">Empowering Homeless Services Through Technology</p>
          <p className="text-gray-400 mt-4">Email: beta@sheltercareconnect.com</p>
        </div>
      </footer>
    </div>
  );
};

export default MarketingLayout;